// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_attachments_view from "./web_attachments_view.js";
import * as Mapre_web__Web_checkpoint_view from "./web_checkpoint_view.js";
import * as Mapre_web__Web_comments_view from "./web_comments_view.js";
import * as Mapre_web__Web_invitation_view from "./web_invitation_view.js";
import * as Mapre_web__Web_message_view from "./web_message_view.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_permissions_view from "./web_permissions_view.js";
import * as Mapre_web__Web_publication_view from "./web_publication_view.js";
import * as Mapre_web__Web_resume_view from "./web_resume_view.js";
import * as Mapre_web__Web_session_usage_view from "./web_session_usage_view.js";
import * as Mapre_web__Web_settings_shell from "./web_settings_shell.js";
import * as Mapre_web__Web_sidebar from "./web_sidebar.js";
import * as Mapre_web__Web_subscription_view from "./web_subscription_view.js";
import * as Mapre_web__Web_transcript from "./web_transcript.js";
import * as Mapre_web__Web_types from "./web_types.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

function field(source, get, label, change, send) {
  const partial_arg = label;
  const partial_arg$1 = "muted";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___001_) {
        const partial_arg = (function (param) {
          return Lui_elements.on_input(send, change, param);
        });
        const partial_arg$1 = label;
        const partial_arg$2 = label;
        const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map(get, source)));
        return function (param, param$1) {
          return Lui_elements.text_field(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, partial_arg$2, undefined, partial_arg$1, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$2 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$3 = 6;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, param, param$1);
  };
}

function session_limits_view(source, send) {
  const partial_arg = "Leave blank for twelve hours, or enter a UTC time such as YYYY-MM-DDTHH:mm:ss.sssZ.";
  const partial_arg$1 = "muted";
  const partial_arg_0 = field(source, (function (m) {
    return Stdlib__Option.fold("", (function (f) {
      return f.budget;
    }), m.form);
  }), "Budget (USD)", (function (value) {
    return {
      TAG: /* Budget */ 19,
      _0: value
    };
  }), send);
  const partial_arg_1 = {
    hd: field(source, (function (m) {
      return Stdlib__Option.fold("", (function (f) {
        return f.deadline;
      }), m.form);
    }), "Stop at (UTC, optional)", (function (value) {
      return {
        TAG: /* Deadline */ 20,
        _0: value
      };
    }), send),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      }),
      tl: /* [] */ 0
    }
  };
  const partial_arg$2 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$3 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, param, param$1);
  };
}

function form_view(source, send) {
  const partial_arg = "Instructions";
  const partial_arg$1 = "muted";
  const partial_arg$2 = (function (param) {
    return Lui_elements.press(send, /* Close_form */ 3, param);
  });
  const partial_arg$3 = "ghost";
  const partial_arg$4 = "Cancel";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___005_) {
      const partial_arg = (function (param) {
        return Lui_elements.press(send, /* Submit */ 4, param);
      });
      const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (m) {
        return !Mapre_web__Web_model.can_submit(m);
      }), source)));
      const partial_arg$2 = "primary";
      const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (m) {
        const f = m.form;
        if (f !== undefined && f.pending) {
          return "Starting...";
        } else {
          return "Start session";
        }
      }), source)));
      return function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$5 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$6 = 8;
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___002_) {
      const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (m) {
        if (Stdlib__Option.bind(m.form, (function (f) {
            return f.source;
          })) !== undefined) {
          return "New child session";
        } else {
          return "New session";
        }
      }), source)));
      const partial_arg$1 = 2;
      return function (param, param$1) {
        return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1$1 = {
    hd: Mapre_web__Web_subscription_view.view(source, send),
    tl: {
      hd: field(source, (function (m) {
        return Stdlib__Option.fold("", (function (f) {
          return f.title;
        }), m.form);
      }), "Title", (function (value) {
        return {
          TAG: /* Title */ 17,
          _0: value
        };
      }), send),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        }),
        tl: {
          hd: Mapre_web__Web_attachments_view.input(/* Initial */ 0, source, send, {
            hd: (function (param, param$1) {
              return Lui_elements.scoped((function (__lui_context___003_) {
                const partial_arg = (function (param) {
                  return Lui_elements.on_input(send, (function (value) {
                    return {
                      TAG: /* Prompt */ 18,
                      _0: value
                    };
                  }), param);
                });
                const partial_arg$1 = "Instructions";
                const partial_arg$2 = "Describe the task for your coding agent.";
                const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (m) {
                  return Stdlib__Option.fold("", (function (f) {
                    return f.prompt;
                  }), m.form);
                }), source)));
                return function (param, param$1) {
                  return Lui_elements.textarea(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, partial_arg$2, undefined, partial_arg$1, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                };
              }), param, param$1);
            }),
            tl: /* [] */ 0
          }),
          tl: {
            hd: session_limits_view(source, send),
            tl: {
              hd: (function (param, param$1) {
                return Lui_elements.scoped((function (__lui_context___004_) {
                  const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (m) {
                    const match = Stdlib__Option.bind(m.form, (function (f) {
                      return f.source;
                    }));
                    const match$1 = m.templates;
                    if (match !== undefined) {
                      return "Source: parent checkpoint with current project files.";
                    } else if (match$1) {
                      return "Project template revision " + String(match$1.hd.revision);
                    } else {
                      return "No ready template. Prepare a project template before starting a session.";
                    }
                  }), source)));
                  const partial_arg$1 = "muted";
                  return function (param, param$1) {
                    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  };
                }), param, param$1);
              }),
              tl: {
                hd: (function (param, param$1) {
                  return Lui_elements.row(undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, param, param$1);
                }),
                tl: /* [] */ 0
              }
            }
          }
        }
      }
    }
  };
  const partial_arg$7 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$8 = "form-card";
  const partial_arg$9 = 0;
  const partial_arg$10 = 16;
  const partial_arg$11 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, param, param$1);
  };
}

function workspace_form_view(source, send) {
  const value = function (get, m) {
    return Stdlib__Option.fold("", get, m.workspace_form);
  };
  const partial_arg = "Create a workspace";
  const partial_arg$1 = 2;
  const partial_arg$2 = "You will own this workspace. New sessions use its timezone for journal placement.";
  const partial_arg$3 = "muted";
  const partial_arg$4 = (function (param) {
    return Lui_elements.press(send, /* Close_workspace */ 10, param);
  });
  const partial_arg$5 = "ghost";
  const partial_arg$6 = "Cancel workspace";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___006_) {
      const partial_arg = (function (param) {
        return Lui_elements.press(send, /* Create_workspace */ 11, param);
      });
      const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___006_.ui_scope, Signal.map((function (m) {
        return !Mapre_web__Web_model.can_create_workspace(m);
      }), source)));
      const partial_arg$2 = "primary";
      const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___006_.ui_scope, Signal.map((function (m) {
        const f = m.workspace_form;
        if (f !== undefined && f.pending) {
          return "Creating...";
        } else {
          return "Create workspace";
        }
      }), source)));
      return function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$7 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$8 = 8;
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1$1 = {
    hd: field(source, (function (param) {
      return value((function (f) {
        return f.name;
      }), param);
    }), "Workspace name", (function (text) {
      return {
        TAG: /* Workspace_name */ 30,
        _0: text
      };
    }), send),
    tl: {
      hd: field(source, (function (param) {
        return value((function (f) {
          return f.timezone;
        }), param);
      }), "Timezone", (function (text) {
        return {
          TAG: /* Workspace_timezone */ 31,
          _0: text
        };
      }), send),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.row(undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, param, param$1);
          }),
          tl: /* [] */ 0
        }
      }
    }
  };
  const partial_arg$9 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$10 = "form-card";
  const partial_arg$11 = 16;
  const partial_arg$12 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, param, param$1);
  };
}

function heading_text(m) {
  const s = m.selected;
  if (s !== undefined) {
    return s.title;
  }
  const p = Mapre_web__Web_types.project(m.route);
  if (p !== undefined) {
    return Stdlib__Option.fold("Project", (function (p) {
      return p.name;
    }), Stdlib__List.find_opt((function (item) {
      return item.id === p;
    }), m.projects));
  } else {
    return "Your workspace";
  }
}

function subtitle_text(model) {
  const s = model.selected;
  if (s !== undefined) {
    return Mapre_web__Web_types.status(s.status) + (" / " + model.connection);
  }
  const p = Stdlib__List.find_opt((function (p) {
    return Caml_obj.caml_equal(p.id, Mapre_web__Web_types.project(model.route));
  }), model.projects);
  if (p !== undefined) {
    return p.repository;
  } else {
    return "Build together with coding agents.";
  }
}

function forms(source, send) {
  const partial_arg = form_view(source, send);
  const partial_arg$1 = Signal.map((function (m) {
    return m.form !== undefined;
  }), source);
  const partial_arg$2 = workspace_form_view(source, send);
  const partial_arg$3 = Signal.map((function (m) {
    return m.workspace_form !== undefined;
  }), source);
  const partial_arg$4 = Mapre_web__Web_invitation_view.view(source, send);
  const partial_arg$5 = Signal.map((function (m) {
    const f = m.invitation_form;
    if (f === undefined) {
      return false;
    }
    const match = f.mode;
    if (/* tag */ typeof match !== "object" && typeof match !== "function") {
      return false;
    } else {
      return true;
    }
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.if_(partial_arg$1, partial_arg, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$3, partial_arg$2, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$5, partial_arg$4, param, param$1);
      }),
      tl: /* [] */ 0
    }
  };
  const partial_arg$6 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$7 = 0;
  const partial_arg$8 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, param, param$1);
  };
}

function session_ops(source, send) {
  const partial_arg = (function (param) {
    return Lui_elements.press(send, /* Close_session_panel */ 16, param);
  });
  const partial_arg$1 = "sm";
  const partial_arg$2 = "ghost";
  const partial_arg$3 = "Close session actions";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$4 = {
    hd: partial_arg_0,
    tl: /* [] */ 0
  };
  const partial_arg$5 = "end_";
  const partial_arg$6 = Mapre_web__Web_publication_view.view(source, send);
  const partial_arg$7 = Signal.map((function (m) {
    return Caml_obj.caml_equal(m.session_panel, /* Review_panel */ 0);
  }), source);
  const partial_arg$8 = Mapre_web__Web_checkpoint_view.view(source, send);
  const partial_arg$9 = Signal.map((function (m) {
    return Caml_obj.caml_equal(m.session_panel, /* Checkpoint_panel */ 1);
  }), source);
  const partial_arg$10 = Mapre_web__Web_comments_view.view(source, send);
  const partial_arg$11 = Signal.map((function (m) {
    return Caml_obj.caml_equal(m.session_panel, /* Comments_panel */ 2);
  }), source);
  const partial_arg$12 = Mapre_web__Web_session_usage_view.view(source, send);
  const partial_arg$13 = Signal.map((function (m) {
    return Caml_obj.caml_equal(m.session_panel, /* Usage_panel */ 3);
  }), source);
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.if_(partial_arg$7, partial_arg$6, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$9, partial_arg$8, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$11, partial_arg$10, param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.if_(partial_arg$13, partial_arg$12, param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.scoped((function (__lui_context___007_) {
              const partial_arg = Mapre_web__Web_resume_view.view(source, send);
              const partial_arg$1 = Signal.own_signal(__lui_context___007_.ui_scope, Signal.map((function (m) {
                return Caml_obj.caml_equal(m.session_panel, /* Settings_panel */ 4);
              }), source));
              return function (param, param$1) {
                return Lui_elements.if_(partial_arg$1, partial_arg, param, param$1);
              };
            }), param, param$1);
          }),
          tl: /* [] */ 0
        }
      }
    }
  };
  const partial_arg$14 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1
  };
  const partial_arg$15 = 0;
  const partial_arg_0$2 = function (param, param$1) {
    return Lui_elements.column(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$15, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$14, param, param$1);
  };
  const partial_arg$16 = {
    hd: partial_arg_0$2,
    tl: /* [] */ 0
  };
  const partial_arg$17 = 300;
  const partial_arg$18 = 128;
  const partial_arg$19 = 240;
  const partial_arg_0$3 = function (param, param$1) {
    return Lui_elements.row(undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scroll(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$19, undefined, undefined, partial_arg$18, partial_arg$17, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$16, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$20 = {
    hd: partial_arg_0$3,
    tl: partial_arg_1$1
  };
  const partial_arg$21 = "session-ops";
  const partial_arg$22 = 180;
  const partial_arg$23 = 0;
  const partial_arg$24 = 12;
  const partial_arg$25 = 8;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$25, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$24, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$23, undefined, undefined, partial_arg$22, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$21, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$20, param, param$1);
  };
}

function menu_entry(send, enabledOpt, source, text, action) {
  const enabled = enabledOpt !== undefined ? enabledOpt : (function (param) {
      return true;
    });
  const partial_arg = (function (param) {
    Curry._1(send, action);
    Curry._1(send, /* Close_menu */ 15);
  });
  const partial_arg$1 = Caml_option.some(Signal.map((function (m) {
    return !Curry._1(enabled, m);
  }), source));
  const partial_arg$2 = text;
  return function (param, param$1) {
    return Lui_elements.menu_item(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
}

function session_menu(send, source) {
  const partial_arg = menu_entry(send, undefined, source, "Review and publish", {
    TAG: /* Open_session_panel */ 51,
    _0: /* Review_panel */ 0
  });
  const partial_arg$1 = Signal.map((function (m) {
    return m.selected !== undefined;
  }), source);
  const partial_arg$2 = menu_entry(send, undefined, source, "Parent checkpoint", {
    TAG: /* Open_session_panel */ 51,
    _0: /* Checkpoint_panel */ 1
  });
  const partial_arg$3 = Signal.map((function (m) {
    return m.selected !== undefined;
  }), source);
  const partial_arg$4 = menu_entry(send, undefined, source, "Comments", {
    TAG: /* Open_session_panel */ 51,
    _0: /* Comments_panel */ 2
  });
  const partial_arg$5 = Signal.map((function (m) {
    return m.selected !== undefined;
  }), source);
  const partial_arg$6 = menu_entry(send, undefined, source, "Session usage", {
    TAG: /* Session_usage */ 39,
    _0: /* Open */ 0
  });
  const partial_arg$7 = Signal.map((function (m) {
    return m.selected !== undefined;
  }), source);
  return {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$1, partial_arg, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$3, partial_arg$2, param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.if_(partial_arg$5, partial_arg$4, param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.if_(partial_arg$7, partial_arg$6, param, param$1);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.scoped((function (__lui_context___008_) {
                const partial_arg = menu_entry(send, undefined, source, "Session settings", {
                  TAG: /* Open_session_panel */ 51,
                  _0: /* Settings_panel */ 4
                });
                const partial_arg$1 = Signal.own_signal(__lui_context___008_.ui_scope, Signal.map((function (m) {
                  if (m.selected !== undefined) {
                    return Mapre_web__Web_model.can_create(m);
                  } else {
                    return false;
                  }
                }), source));
                return function (param, param$1) {
                  return Lui_elements.if_(partial_arg$1, partial_arg, param, param$1);
                };
              }), param, param$1);
            }),
            tl: /* [] */ 0
          }
        }
      }
    }
  };
}

function overflow_menu(send, source) {
  const partial_arg = {
    TAG: /* Open_menu */ 50,
    _0: "topbar"
  };
  const partial_arg$1 = (function (param) {
    return Lui_elements.press(send, partial_arg, param);
  });
  const partial_arg$2 = "Session and project actions";
  const partial_arg$3 = {
    NAME: "app",
    VAL: "ellipsis"
  };
  const partial_arg$4 = "icon";
  const partial_arg$5 = "ghost";
  const partial_arg$6 = Stdlib.$at(session_menu(send, source), {
    hd: menu_entry(send, undefined, source, "App settings", {
      TAG: /* Settings */ 37,
      _0: {
        TAG: /* Open */ 0,
        _0: ""
      }
    }),
    tl: {
      hd: menu_entry(send, undefined, source, "Accounts", {
        TAG: /* Accounts */ 41,
        _0: {
          TAG: /* Open */ 0,
          _0: ""
        }
      }),
      tl: {
        hd: menu_entry(send, (function (m) {
          return Mapre_web__Web_types.workspace(m.route) !== undefined;
        }), source, "Logseq", {
          TAG: /* Graph */ 36,
          _0: {
            TAG: /* Open */ 0,
            _0: ""
          }
        }),
        tl: {
          hd: menu_entry(send, Mapre_web__Web_model.can_edit_environment, source, "Templates", {
            TAG: /* Build */ 34,
            _0: {
              TAG: /* Open */ 0,
              _0: ""
            }
          }),
          tl: {
            hd: menu_entry(send, Mapre_web__Web_model.can_edit_environment, source, "Pull requests", {
              TAG: /* Pulls */ 35,
              _0: {
                TAG: /* Open */ 0,
                _0: ""
              }
            }),
            tl: {
              hd: menu_entry(send, Mapre_web__Web_model.can_edit_environment, source, "Edit environment", {
                TAG: /* Environment */ 33,
                _0: {
                  TAG: /* Open */ 0,
                  _0: ""
                }
              }),
              tl: {
                hd: menu_entry(send, Mapre_web__Web_model.can_manage_project, source, "Connect project", {
                  TAG: /* Project_setup */ 32,
                  _0: {
                    TAG: /* Open */ 0,
                    _0: ""
                  }
                }),
                tl: {
                  hd: menu_entry(send, (function (m) {
                    if (Mapre_web__Web_model.can_manage_project(m)) {
                      return Mapre_web__Web_model.can_edit_environment(m);
                    } else {
                      return false;
                    }
                  }), source, "Update repository connection", {
                    TAG: /* Project_setup */ 32,
                    _0: {
                      TAG: /* Rebind */ 1,
                      _0: ""
                    }
                  }),
                  tl: {
                    hd: menu_entry(send, Mapre_web__Web_model.can_manage_members, source, "Invite members", {
                      TAG: /* Invitations */ 48,
                      _0: {
                        TAG: /* Open */ 0,
                        _0: ""
                      }
                    }),
                    tl: /* [] */ 0
                  }
                }
              }
            }
          }
        }
      }
    }
  });
  const partial_arg$7 = (function (param) {
    return Lui_elements.press(send, /* Close_menu */ 15, param);
  });
  const partial_arg$8 = "end_";
  const partial_arg$9 = "below";
  const partial_arg$10 = function (param, param$1) {
    return Lui_elements.dropdown_menu(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, partial_arg$8, undefined, undefined, undefined, undefined, partial_arg$7, undefined, partial_arg$6, param, param$1);
  };
  const partial_arg$11 = Signal.map((function (m) {
    return Caml_obj.caml_equal(m.open_menu, "topbar");
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, partial_arg$4, partial_arg$3, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$11, partial_arg$10, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$12 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  return function (param, param$1) {
    return Lui_elements.stack(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$12, param, param$1);
  };
}

function topbar(send, source) {
  const partial_arg = (function (param) {
    return Lui_elements.press(send, /* Toggle_navigation */ 7, param);
  });
  const partial_arg$1 = "Navigation";
  const partial_arg$2 = {
    NAME: "app",
    VAL: "panel-left"
  };
  const partial_arg$3 = "icon";
  const partial_arg$4 = "ghost";
  const partial_arg$5 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, partial_arg$2, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$6 = Signal.map((function (m) {
    if (m.sidebar_collapsed || m.compact) {
      return !Mapre_web__Web_model.locked(m);
    } else {
      return false;
    }
  }), source);
  const partial_arg$7 = Signal.map((function (m) {
    return subtitle_text(m) !== "";
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___009_) {
      const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___009_.ui_scope, Signal.map(heading_text, source)));
      const partial_arg$1 = 1;
      const partial_arg$2 = "pane-title";
      return function (param, param$1) {
        return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$7, (function (param, param$1) {
        return Lui_elements.scoped((function (__lui_context___010_) {
          const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___010_.ui_scope, Signal.map(subtitle_text, source)));
          const partial_arg$1 = "muted";
          return function (param, param$1) {
            return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
        }), param, param$1);
      }), param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$8 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$9 = 0;
  const partial_arg$10 = 1;
  const partial_arg$11 = 2;
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.if_(partial_arg$6, partial_arg$5, param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.column(undefined, partial_arg$11, undefined, undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, param, param$1);
    }),
    tl: {
      hd: overflow_menu(send, source),
      tl: /* [] */ 0
    }
  };
  const partial_arg$12 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$13 = "topbar";
  const partial_arg$14 = 0;
  const partial_arg$15 = 8;
  const partial_arg$16 = 12;
  const partial_arg$17 = "center";
  const partial_arg$18 = 12;
  return function (param, param$1) {
    return Lui_elements.row(undefined, partial_arg$18, undefined, partial_arg$17, undefined, undefined, undefined, partial_arg$16, partial_arg$15, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$14, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$13, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$12, param, param$1);
  };
}

function locked_view(send, source) {
  const partial_arg = "Mapre";
  const partial_arg$1 = 1;
  const partial_arg$2 = "brand";
  const partial_arg$3 = "A shared place to build.";
  const partial_arg$4 = "muted";
  const partial_arg$5 = "Loading Mapre...";
  const partial_arg$6 = "muted";
  const partial_arg$7 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$8 = Signal.map((function (m) {
    return Caml_obj.caml_equal(m.entry, /* Loading */ 0);
  }), source);
  const partial_arg$9 = Signal.map((function (m) {
    return m.notice !== "";
  }), source);
  const partial_arg$10 = Signal.map((function (m) {
    const match = m.entry;
    if (/* tag */ typeof match !== "object" && typeof match !== "function") {
      return false;
    } else {
      return m.github_login;
    }
  }), source);
  const partial_arg$11 = (function (param) {
    return Lui_elements.press(send, /* Retry_loading */ 6, param);
  });
  const partial_arg$12 = "outline";
  const partial_arg$13 = "Retry connection";
  const partial_arg$14 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$13, undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$15 = Signal.map((function (m) {
    return Caml_obj.caml_equal(m.entry, /* Load_failed */ 2);
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$8, partial_arg$7, param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.if_(partial_arg$9, (function (param, param$1) {
            return Lui_elements.scoped((function (__lui_context___011_) {
              const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___011_.ui_scope, Signal.map((function (m) {
                return m.notice;
              }), source)));
              const partial_arg$1 = "notice";
              return function (param, param$1) {
                return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }), param, param$1);
          }), param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.if_(partial_arg$10, (function (param, param$1) {
              return Lui_elements.scoped((function (__lui_context___012_) {
                const partial_arg = "Sign in with GitHub";
                const partial_arg$1 = "self_";
                const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___012_.ui_scope, Signal.map((function (m) {
                  return "/auth/github/start?return_to=" + Mapre_web__Web_types.path(m.route);
                }), source)));
                return function (param, param$1) {
                  return Lui_elements.link(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                };
              }), param, param$1);
            }), param, param$1);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.if_(partial_arg$15, partial_arg$14, param, param$1);
            }),
            tl: /* [] */ 0
          }
        }
      }
    }
  };
  const partial_arg$16 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$17 = "locked";
  const partial_arg$18 = 24;
  const partial_arg$19 = 1;
  const partial_arg$20 = "center";
  const partial_arg$21 = "center";
  const partial_arg$22 = 16;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$22, partial_arg$21, partial_arg$20, partial_arg$19, undefined, undefined, partial_arg$18, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$17, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$16, param, param$1);
  };
}

function welcome(source) {
  const partial_arg = "Mapre";
  const partial_arg$1 = "hero-mark";
  const partial_arg$2 = "Build together with coding agents.";
  const partial_arg$3 = "muted";
  const partial_arg$4 = "Choose a chat on the left, or start a new one.";
  const partial_arg$5 = "muted";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      }),
      tl: /* [] */ 0
    }
  };
  const partial_arg$6 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$7 = "empty";
  const partial_arg$8 = 24;
  const partial_arg$9 = 1;
  const partial_arg$10 = "center";
  const partial_arg$11 = "center";
  const partial_arg$12 = 8;
  const partial_arg$13 = function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$12, partial_arg$11, partial_arg$10, partial_arg$9, undefined, undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, param, param$1);
  };
  const partial_arg$14 = Signal.map((function (m) {
    if (m.selected === undefined && m.form === undefined && m.workspace_form === undefined) {
      return m.invitation_form === undefined;
    } else {
      return false;
    }
  }), source);
  return function (param, param$1) {
    return Lui_elements.if_(partial_arg$14, partial_arg$13, param, param$1);
  };
}

function transcript_section(min_height, content) {
  const partial_arg = {
    hd: content,
    tl: /* [] */ 0
  };
  const partial_arg$1 = 768;
  const partial_arg$2 = 0;
  const partial_arg$3 = 12;
  const partial_arg$4 = 1;
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.column(undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, min_height, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, param, param$1);
  };
  const partial_arg$5 = {
    hd: partial_arg_0,
    tl: /* [] */ 0
  };
  const partial_arg$6 = 0;
  const partial_arg$7 = "stretch";
  const partial_arg$8 = "center";
  return function (param, param$1) {
    return Lui_elements.row(undefined, undefined, partial_arg$8, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, min_height, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, param, param$1);
  };
}

function transcript_body(send, source) {
  const partial_arg_0 = forms(source, send);
  const partial_arg = {
    hd: partial_arg_0,
    tl: /* [] */ 0
  };
  const partial_arg$1 = 420;
  const partial_arg$2 = 0;
  const partial_arg$3 = transcript_section(0, (function (param, param$1) {
    return Lui_elements.scroll(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, param, param$1);
  }));
  const partial_arg$4 = Signal.map((function (m) {
    if (m.form !== undefined) {
      return true;
    }
    if (m.workspace_form !== undefined) {
      return true;
    }
    const f = m.invitation_form;
    if (f !== undefined) {
      return Caml_obj.caml_notequal(f.mode, /* Manage */ 0);
    } else {
      return false;
    }
  }), source);
  const partial_arg$5 = transcript_section(undefined, Mapre_web__Web_permissions_view.view(source, send));
  const partial_arg$6 = Signal.map((function (m) {
    return m.selected !== undefined;
  }), source);
  const partial_arg$7 = transcript_section(undefined, session_ops(source, send));
  const partial_arg$8 = Signal.map((function (m) {
    if (m.selected !== undefined) {
      return m.session_panel !== undefined;
    } else {
      return false;
    }
  }), source);
  const partial_arg$9 = Mapre_web__Web_transcript.view(send, source);
  const partial_arg$10 = Signal.map((function (m) {
    return m.selected !== undefined;
  }), source);
  return {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$4, partial_arg$3, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$6, partial_arg$5, param, param$1);
      }),
      tl: {
        hd: welcome(source),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.if_(partial_arg$8, partial_arg$7, param, param$1);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.if_(partial_arg$10, partial_arg$9, param, param$1);
            }),
            tl: /* [] */ 0
          }
        }
      }
    }
  };
}

function chat_main(send, source) {
  return function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___014_) {
      const partial_arg = Signal.map((function (m) {
        return m.notice !== "";
      }), source);
      const partial_arg$1 = transcript_body(send, source);
      const partial_arg$2 = {
        hd: [
          "data-anchor-scope",
          "transcript"
        ],
        tl: /* [] */ 0
      };
      const partial_arg$3 = "transcript-wrap";
      const partial_arg$4 = 0;
      const partial_arg$5 = 0;
      const partial_arg$6 = 1;
      const partial_arg$7 = 8;
      const partial_arg_0 = function (param, param$1) {
        return Lui_elements.column(undefined, partial_arg$7, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, param, param$1);
      };
      const partial_arg$8 = {
        hd: partial_arg_0,
        tl: /* [] */ 0
      };
      const partial_arg$9 = 0;
      const partial_arg$10 = 0;
      const partial_arg$11 = 1;
      const partial_arg$12 = "stretch";
      const partial_arg$13 = "center";
      const partial_arg_0$1 = Mapre_web__Web_message_view.view(source, send);
      const partial_arg$14 = {
        hd: partial_arg_0$1,
        tl: /* [] */ 0
      };
      const partial_arg$15 = 768;
      const partial_arg$16 = 0;
      const partial_arg$17 = 1;
      const partial_arg_0$2 = function (param, param$1) {
        return Lui_elements.column(undefined, undefined, undefined, undefined, partial_arg$17, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$16, partial_arg$15, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$14, param, param$1);
      };
      const partial_arg$18 = {
        hd: partial_arg_0$2,
        tl: /* [] */ 0
      };
      const partial_arg$19 = 0;
      const partial_arg$20 = "center";
      const partial_arg_0$3 = function (param, param$1) {
        return Lui_elements.row(undefined, undefined, partial_arg$20, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$19, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$18, param, param$1);
      };
      const partial_arg$21 = {
        hd: partial_arg_0$3,
        tl: /* [] */ 0
      };
      const partial_arg$22 = "composer-zone";
      const partial_arg$23 = 0;
      const partial_arg$24 = function (param, param$1) {
        return Lui_elements.column(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$23, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$22, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$21, param, param$1);
      };
      const partial_arg$25 = Signal.map((function (m) {
        if (m.selected !== undefined) {
          return !Mapre_web__Web_model.locked(m);
        } else {
          return false;
        }
      }), source);
      const partial_arg_0$4 = topbar(send, source);
      const partial_arg_1 = {
        hd: (function (param, param$1) {
          return Lui_elements.if_(partial_arg, (function (param, param$1) {
            return Lui_elements.scoped((function (__lui_context___015_) {
              const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___015_.ui_scope, Signal.map((function (m) {
                return m.notice;
              }), source)));
              const partial_arg$1 = "notice";
              const partial_arg$2 = 16;
              return function (param, param$1) {
                return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }), param, param$1);
          }), param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.row(undefined, undefined, partial_arg$13, partial_arg$12, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, param, param$1);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.if_(partial_arg$25, partial_arg$24, param, param$1);
            }),
            tl: /* [] */ 0
          }
        }
      };
      const partial_arg$26 = {
        hd: partial_arg_0$4,
        tl: partial_arg_1
      };
      const partial_arg$27 = Caml_option.some(Signal.own_signal(__lui_context___014_.ui_scope, Signal.map((function (m) {
        if (m.compact && m.navigation_open) {
          return "none";
        } else {
          return "inline_flex";
        }
      }), source)));
      const partial_arg$28 = "chat-main";
      const partial_arg$29 = 0;
      const partial_arg$30 = 0;
      const partial_arg$31 = 1;
      return function (param, param$1) {
        return Lui_elements.column(undefined, undefined, undefined, undefined, partial_arg$31, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$30, undefined, undefined, partial_arg$29, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$28, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$27, undefined, undefined, partial_arg$26, param, param$1);
      };
    }), param, param$1);
  };
}

function view(_context, source, send) {
  const partial_arg = locked_view(send, source);
  const partial_arg$1 = Signal.map(Mapre_web__Web_model.locked, source);
  const partial_arg$2 = Mapre_web__Web_settings_shell.nav_pane(send, source);
  const partial_arg$3 = Signal.map((function (m) {
    if (Mapre_web__Web_model.pane(m) !== undefined) {
      return Mapre_web__Web_settings_shell.nav_visible(m);
    } else {
      return false;
    }
  }), source);
  const partial_arg$4 = Mapre_web__Web_sidebar.view(send, source);
  const partial_arg$5 = Signal.map((function (m) {
    if (Mapre_web__Web_model.pane(m) === undefined) {
      if (m.compact) {
        return m.navigation_open;
      } else {
        return !m.sidebar_collapsed;
      }
    } else {
      return false;
    }
  }), source);
  const partial_arg$6 = Mapre_web__Web_settings_shell.content(send, source);
  const partial_arg$7 = Signal.map((function (m) {
    return Mapre_web__Web_model.pane(m) !== undefined;
  }), source);
  const partial_arg$8 = chat_main(send, source);
  const partial_arg$9 = Signal.map((function (m) {
    return Mapre_web__Web_model.pane(m) === undefined;
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.if_(partial_arg$3, partial_arg$2, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$5, partial_arg$4, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$7, partial_arg$6, param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.if_(partial_arg$9, partial_arg$8, param, param$1);
        }),
        tl: /* [] */ 0
      }
    }
  };
  const partial_arg$10 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$11 = "app-body";
  const partial_arg$12 = 0;
  const partial_arg$13 = 0;
  const partial_arg$14 = 1;
  const partial_arg$15 = function (param, param$1) {
    return Lui_elements.row(undefined, undefined, undefined, undefined, partial_arg$14, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$13, undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, param, param$1);
  };
  const partial_arg$16 = Signal.map((function (m) {
    return !Mapre_web__Web_model.locked(m);
  }), source);
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.if_(partial_arg$1, partial_arg, param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$16, partial_arg$15, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$17 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$18 = "application";
  const partial_arg$19 = 0;
  return function (param, param$1) {
    return Lui_elements.column(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$19, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$18, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$17, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
